import { useEffect, useState } from "react";
import {
  addClass,
  getClasses,
  deleteClass,
} from "../services/firebaseService";

export default function Classes() {
  const [className, setClassName] = useState("");
  const [section, setSection] = useState("");
  const [status, setStatus] = useState("Active");
  const [classes, setClasses] = useState([]);

  useEffect(() => {
    getClasses(setClasses);
  }, []);

  const handleSave = async () => {
    if (!className.trim()) {
      alert("Please enter Class Name");
      return;
    }

    const newClass = {
      className: className.trim(),
      section: section.trim().toUpperCase(),
      status,
      createdAt: Date.now(),
    };

    try {
      await addClass(newClass);

      setClassName("");
      setSection("");
      setStatus("Active");
    } catch (error) {
      console.error(error);
      alert("Failed to save class.");
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Delete this class?")) return;

    try {
      await deleteClass(id);
    } catch (error) {
      console.error(error);
      alert("Failed to delete class.");
    }
  };

  return (
    <div
      style={{
        maxWidth: "700px",
        margin: "20px auto",
        padding: "15px",
      }}
    >
      <h2 style={{ marginBottom: "20px" }}>
        Class & Section Management
      </h2>

      <div
        style={{
          background: "#fff",
          padding: "20px",
          borderRadius: "10px",
          boxShadow: "0 2px 10px rgba(0,0,0,.08)",
        }}
      >
        <div style={{ marginBottom: "15px" }}>
          <label>Class Name *</label>

          <input
            type="text"
            placeholder="Example : Class 6"
            value={className}
            onChange={(e) => setClassName(e.target.value)}
            style={{
              width: "100%",
              padding: "12px",
              marginTop: "5px",
              borderRadius: "8px",
              border: "1px solid #ccc",
              boxSizing: "border-box",
            }}
          />
        </div>

        <div style={{ marginBottom: "15px" }}>
          <label>Section</label>

          <input
            type="text"
            placeholder="Example : A"
            value={section}
            onChange={(e) => setSection(e.target.value.toUpperCase())}
            style={{
              width: "100%",
              padding: "12px",
              marginTop: "5px",
              borderRadius: "8px",
              border: "1px solid #ccc",
              boxSizing: "border-box",
            }}
          />
        </div>

        <div style={{ marginBottom: "20px" }}>
          <label>Status</label>

          <select
            value={status}
            onChange={(e) => setStatus(e.target.value)}
            style={{
              width: "100%",
              padding: "12px",
              marginTop: "5px",
              borderRadius: "8px",
            }}
          >
            <option value="Active">Active</option>
            <option value="Inactive">Inactive</option>
          </select>
        </div>

        <button
          onClick={handleSave}
          style={{
            width: "100%",
            padding: "14px",
            background: "#2563eb",
            color: "#fff",
            border: "none",
            borderRadius: "8px",
            cursor: "pointer",
            fontWeight: "bold",
          }}
        >
          Save Class
        </button>
      </div>

      <div
        style={{
          marginTop: "25px",
          background: "#fff",
          borderRadius: "10px",
          padding: "15px",
          boxShadow: "0 2px 10px rgba(0,0,0,.08)",
        }}
      >
        <h3>Classes ({classes.length})</h3>

        {classes.length === 0 ? (
          <p>No Classes Added.</p>
        ) : (
          classes.map((item) => (
            <div
              key={item.id}
              style={{
                marginTop: "15px",
                border: "1px solid #ddd",
                borderRadius: "10px",
                padding: "15px",
              }}
            >
              <h3>
                {item.className}
                {item.section ? ` - ${item.section}` : ""}
              </h3>

              <p>
                <strong>Status:</strong> {item.status}
              </p>

              <button
                onClick={() => handleDelete(item.id)}
                style={{
                  background: "#dc2626",
                  color: "#fff",
                  border: "none",
                  padding: "10px 18px",
                  borderRadius: "6px",
                  cursor: "pointer",
                }}
              >
                Delete
              </button>
            </div>
          ))
        )}
      </div>
    </div>
  );
}